import * as Yup from "yup";
import { settingsService } from "../services";

export const USERNAME_ALLOWED_REGEX = /^[a-z0-9]+$/;

export const profileSchema = Yup.object({
  username: Yup.string()
    .min(3, "Must be at least 3 characters")
    .required("Required"),
  name: Yup.string().required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
});

export const passwordSchema = Yup.object({
  currentPassword: Yup.string().required("Required"),
  newPassword: Yup.string()
    .min(8, "Must be at least 8 characters") // Password length is set to 8 characters to match the API requirement
    .required("Required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword")], "Passwords must match")
    .required("Required"),
});

export const makeUniqueValidator =
  (cacheRef, userId, fieldKey, translate, delay = 400) =>
  (value) => {
    if (!value) return Promise.resolve(undefined);
    const cache = cacheRef.current[fieldKey];
    if (fieldKey === "username") {
      const formatError = !USERNAME_ALLOWED_REGEX.test(value)
        ? translate(
            "Username can only contain lowercase letters and numbers without spaces.",
          )
        : undefined;

      if (formatError) {
        cache.result = formatError;
        return Promise.resolve(formatError);
      }
    }

    if (cache.value === value && cache.result !== undefined) {
      return Promise.resolve(cache.result);
    }
    cache.value = value;
    if (cache.timer) {
      clearTimeout(cache.timer);
    }

    return new Promise((resolve) => {
      cache.timer = setTimeout(async () => {
        try {
          const data = await settingsService.checkUnique(
            {
              [fieldKey]: value,
              excludeUserId: userId,
            },
            { showErrorToast: false },
          );
          if (data) {
            const payload = data?.data || data || {};
            const exists =
              fieldKey === "username"
                ? Boolean(payload?.usernameExists)
                : Boolean(payload?.emailExists);
            cache.result = exists
              ? translate(`settings.${fieldKey}Exists`)
              : undefined;
          } else {
            cache.result = undefined;
          }
        } catch (error) {
          cache.result = undefined;
        }
        resolve(cache.result);
      }, delay);
    });
  };
